import { ClientCustomCalendarModel } from '../../../../models';
import { getEndMonthDate } from '../../../../util';
import { getCustomCalendarPeriodEndDate } from '../../../../util/customCalendarPeriods';
import { ReportSettingROUAssetsState } from '../ROUAssets';

export const getReportEndDateROUAssets = (
  reportSettingState: ReportSettingROUAssetsState,
  customCalendarSettings: ClientCustomCalendarModel,
): Date => {
  const { reportEndDate } = reportSettingState;

  // if custom calendar client, do not get last day of month, use endDate as is
  if (customCalendarSettings.isCustomCalendarEnabled) {
    return getCustomCalendarPeriodEndDate(
      reportEndDate,
      customCalendarSettings,
    );
  }

  return getEndMonthDate(reportEndDate);
};
